import React, { createContext, useContext, useState, useEffect } from 'react';
import { structuresApi } from '../utils/api';
import { useAuth } from './AuthContext';
import { isStructureLocked } from '../utils/permissions';

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const { user } = useAuth();
  // Un compte de crèche (tablette) est rattaché à une seule structure : on la fixe
  // dès la connexion et le sélecteur du menu est masqué.
  const structureImposee = isStructureLocked(user?.role) ? (user?.structure_id || null) : null;
  const [structures, setStructures] = useState([]);
  const [selectedStructure, setSelectedStructureState] = useState(structureImposee); // null = vue générale (toutes structures)
  const setSelectedStructure = (id) => setSelectedStructureState(structureImposee || id);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (structureImposee) setSelectedStructureState(structureImposee);
  }, [structureImposee]);

  useEffect(() => {
    structuresApi.getAll()
      .then(res => {
        setStructures(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load structures', err);
        setError('Impossible de charger les structures');
        // Use fallback data
        setStructures([
          { id: 1, nom: 'La Cachette des Ptis Lu', couleur: '#1e2d4a' },
          { id: 2, nom: 'La Cachette des Choubidoux', couleur: '#c0985a' },
        ]);
        setLoading(false);
      });
  }, []);

  const getStructureNom = (id) => {
    if (!id) return 'Vue générale';
    const s = structures.find(s => s.id === parseInt(id));
    return s ? s.nom : '—';
  };

  const getApiParams = () => {
    return selectedStructure ? { structure_id: selectedStructure } : {};
  };

  return (
    <AppContext.Provider value={{
      structures,
      selectedStructure,
      setSelectedStructure,
      loading,
      error,
      getStructureNom,
      getApiParams,
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used within AppProvider');
  return ctx;
}

export default AppContext;
